// 3TEK theme JS - cart updates
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-add-to-cart]');
  if (!btn) return;
  e.preventDefault();
  const form = btn.closest('form');
  if (!form) return;
  const fd = new FormData(form);
  btn.disabled = true;
  const original = btn.textContent;
  btn.textContent = '...';
  try {
    const r = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
    if (!r.ok) throw new Error('add failed');
    const cart = await fetch('/cart.js').then(r => r.json());
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    btn.textContent = '✓';
    setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1200);
  } catch (err) {
    btn.textContent = original;
    btn.disabled = false;
    alert('Erreur / Error');
  }
});

// Auto-submit collection filters on change
document.addEventListener('change', function(e){
  var form = e.target.closest && e.target.closest('#CollectionFiltersForm');
  if(form && (e.target.matches('input[type=checkbox]') || e.target.matches('input[type=number]'))){
    form.submit();
  }
});
